<template>
    <div class="mb-20">
        <label
            :for="idOrLabel"
            class="font-bold block mb-5">
            <input
                :id="idOrLabel"
                :autocomplete="autocomplete"
                :checked="modelValue"
                :disabled="disabled"
                :name="idOrLabel"
                :placeholder="placeholder"
                :required="required"
                :step="step"
                class="border-1 border-indigo-400 rounded p-10"
                type="checkbox"
                @change="$emit('change', $event.target.checked);"
                @input="update">
            {{ label }}
        </label>


        <slot name="after-input"/>

        <p v-for="error in errors"
           v-if="errors.length > 0"
           class="mt-5 text-red-500">
            {{ error }}
        </p>

        <p
            v-if="helpText"
            class="mt-5 text-gray-600">
            {{ helpText }}
        </p>
    </div>
</template>

<script>
export default {
    name: "FormCheckbox",
    props: {
        id: String,
        label: String,
        required: Boolean,
        modelValue: [Boolean, String],
        placeholder: String,
        disabled: Boolean,
        helpText: String,
        autocomplete: String,
        step: String | Number,
        errors: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    emits: ['update:modelValue', 'update', 'change'],
    methods: {
        update($event) {
            this.$emit('update:modelValue', $event.target.checked);
            this.$emit('update', $event.target.checked);
        }
    },
    computed: {
        idOrLabel() {
            return this.id ?? this.label;
        },
    }
}
</script>
